import React, { ReactNode, useEffect } from "react";
import { useIsAuthenticated, useMsal, AuthenticatedTemplate } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { loginRequest } from "./authConfig";

interface RequireAuthProps {
    children: ReactNode;
}

const RequireAuth: React.FC<RequireAuthProps> = ({ children }) => {
    const isAuthenticated = useIsAuthenticated();
    const { instance, inProgress } = useMsal();

    useEffect(() => {
        if (!isAuthenticated && inProgress === InteractionStatus.None) {
            instance
                .loginRedirect(loginRequest)
                .catch((error) => console.error("Login redirect failed:", error));
        }
    }, [isAuthenticated, inProgress, instance]);

    if (inProgress === InteractionStatus.Startup || inProgress === InteractionStatus.HandleRedirect) {
        return <div>Loading authentication...</div>;
    }

    if (!isAuthenticated && inProgress === InteractionStatus.None) {
        return <div>Redirecting to login...</div>;
    }

    return (
        <AuthenticatedTemplate>
            {children}
        </AuthenticatedTemplate>
    );
};

export default RequireAuth;